// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__32Nti","colCheckbox":"styles_colCheckbox__1Rdhz"};